import React from 'react';
import { DatePickerStyle } from 'components/Component.style';
import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';

export default function DatePicker({
  label,
  required,
  errMsg,
  disabled,
  onChange,
  value,
  format,
  placeholder,
  ...props
}) {
  return (
    <DatePickerStyle disabled={disabled}>
      <div className="datePickerContainer">
        {label && (
          <div className="lebelView">
            <label>
              {label} {required && <span className="requiredSymbol">*</span>}
            </label>
          </div>
        )}
        <input
          type="date"
          disabled={disabled}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />
        {errMsg && (
          <span className="errMsg">
            <Exclamation />
            {errMsg}
          </span>
        )}
      </div>
    </DatePickerStyle>
  );
}
